export interface DeleteIssue {
  Type: string
  UUID: string
  IsOtherShop: boolean
}

interface Issue {
  value: string
  isOtherShop: boolean
  uuids: string[]
}

export function toIssues(input: DeleteIssue[]): Issue[] {
  const result: Issue[] = []

  return input.reduce((messages, issue) => {
    const matchedMessage = messages.find(message => message.value === issue.Type && message.isOtherShop === issue.IsOtherShop)

    if (matchedMessage) {
      matchedMessage.uuids.push(issue.UUID)
    } else {
      messages.push({
        value: issue.Type,
        isOtherShop: issue.IsOtherShop,
        uuids: [issue.UUID]
      })
    }

    return messages
  }, result)
}
